import * as React from 'react'
import { Tag } from 'react-feather'

import { SchoolPage_school_profile_features } from 'main/pages/School/gql'
import { Strong, Text } from 'main/ui'

import Bullet from '../common/Bullet'

interface IProps {
  profileFeature: SchoolPage_school_profile_features
}

export default function ProfileFeature(props: IProps) {
  const {
    profileFeature: { name, value },
  } = props

  return (
    <Bullet icon={<Tag />}>
      <Strong>{name}</Strong>
      <Text muted>{value}</Text>
    </Bullet>
  )
}
